import { BellOutlined } from '@ant-design/icons';
import { Badge, Button, Empty, Popover } from 'antd';
import { useTranslation } from 'react-i18next';
import LocalizedText from '../components/LocalizedText';

export default function HeaderNotifications({ items = [], loading = false }) {
  const { t } = useTranslation();
  const list = Array.isArray(items) ? items.filter((item) => Number(item.count ?? 0) > 0) : [];
  const unread = list.reduce((sum, item) => sum + Number(item.count || 0), 0);

  const content = (
    <div className="header-notifications">
      <div className="header-notifications__title">{t('common.notifications')}</div>
      {loading ? (
        <div className="header-notifications__empty">{t('common.loading')}</div>
      ) : list.length === 0 ? (
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t('common.noNotifications')} />
      ) : (
        <ul className="header-notifications__list">
          {list.map((item) => (
            <li key={item.key}>
              <button type="button" className="header-notifications__item" onClick={item.onClick}>
                <span>
                  {typeof item.title === 'object'
                    ? <LocalizedText value={item.title} />
                    : item.title}
                </span>
                <b dir="ltr">{item.count}</b>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );

  return (
    <Popover content={content} trigger="click" placement="bottomRight" overlayClassName="header-notifications-popover">
      <Badge count={unread > 99 ? '99+' : unread} size="small" offset={[-2, 2]}>
        <Button
          type="text"
          className="app-header__notifications"
          icon={<BellOutlined />}
          aria-label={t('common.notifications')}
        />
      </Badge>
    </Popover>
  );
}
